import {API_URL, get} from "./apiBase";
import {UserModel} from "@models/user";


/**
 * TO BE IMPLEMENTENTED
 * */


export const getOwnProfile = async (accessToken: string | null) => {
    return fetch(`${API_URL}/user/profile`, {
        method: 'GET',
        headers: {Authorization: `Bearer ${accessToken}`},
    }).then((res) => res.json())
}

export const updateProfile = async (data: UserModel, accessToken: string | null) => {
  return fetch(`${API_URL}/user/update-profile`, {
    method: 'PATCH',
    body: JSON.stringify(data),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json())
}